import React, { Component } from 'react';
// import ImageSelector from '../../../../../../components/ZUILib/ImageSelector';
// import Image from '../../../../../../components/ZUILib/Image';
// import TextInput from '../../../../../../components/ZUILib/TextInput';
// import InputButton from '../../../../../../components/ZUILib/InputButton';
// import KalturaFileUpload from '../../../../../../components/KalturaFileUpload';
import commonUtil from '../../../../../../utils/commonUtil';
// import * as eventDetailsActions from '../actions';
// import * as defaultConst from './../../../../../../utils/clientConstant';

// const { saveEventName } = eventDetailsActions;

export default class EventInfo extends Component {
  state = {
    eventName: '',
    _EventName: '',
    imagePath: '',
  }
// TODO: wap header to be integrated with functionalities
  setValue = (field, e) => {
    switch (field) {
      case 'eventName':
        return this.setState({
          ...this.state,
          eventName: e,
        },
            );
      case 'image':
        return this.setState({
          ...this.state,
          imagePath: e,
        },
            );
      default: break;
    }
    return this.state;
  }
  componentDidMount() {
    if (document.querySelectorAll('.file-upload')) {
      document.querySelectorAll('.file-upload').forEach((item) => { const i = item; i.style.display = 'none'; });
    }
  }
    // image upload functions
  // onFileRemoved = () => {
  // };
  // onError = () => {
  // };
  // onFileSuccess = (data) => {
  //   document.querySelector('#croppieImg').src = data.thumbnailUrl;
  //   const imageURL = data.thumbnailUrl;
  //   saveEventName(this.props.eventID, '', imageURL).then((response) => {
  //     if (response.body.status.status === defaultConst.constAPISuccess) {
  //       this.props._getEventDetails(this.props.eventID);
  //       this.warning.setMessage('');
  //     }
  //   }).catch((e) => {
  //     console.log(e);
  //   });
  // }
  // onMaxFileSizeErrorCallback = () => {
  //   this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
  // }
  // onMinFileSizeErrorCallback = () => {
  //   this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
  // }
  // onFileAddedError = () => {
  //   this.warning.setMessage('Este archivo de extensión no está permitido.');
  // }
  // openProfileImageUploader = () => {
  //   if (document.querySelector('.file-upload')) {
  //     document.querySelector('.file-upload').click();
  //   }
  // }
  render() {
    const { eventDetailsInfo } = this.props;
    // const eventStatusForSuspended = this.props.eventStatusForSuspended;

    let imageUrl = '';
    if (eventDetailsInfo.imageURL) {
      imageUrl = eventDetailsInfo.imageURL;
    } else {
      imageUrl = commonUtil.getAssetURL() + '/images/avatar.svg';
    }
    return (
      <div className="myEventContent">
        <div className="row">
          <div className="col-xs-12">
            <h1>{commonUtil.getLabel(this.props.lables.eventDetails, 'eventManagement.eventDetails.eventData')}</h1>
          </div>
        </div>

        <div className="row eventInfo">
          <div className="col-xs-12">
            <div className="col-xs-3">
              <img id="croppieImg" src={imageUrl} alt="Maria Eugenia &amp; Sergio" className="img-upload-circle" />
              {/* {eventStatusForSuspended === true ? null : <div className="actionUpload">
                <KalturaFileUpload onFileSuccess={this.onFileSuccess} fileAccept="image/*" onFileAddedError={this.onFileAddedError} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} />
              </div>} */}
            </div>

            <div className="col-xs-7">
              {eventDetailsInfo.eventName ?
                <React.Fragment>
                  <p>Nombre del evento:</p>
                  <h3>{commonUtil.sentenceCase(eventDetailsInfo.eventName)}</h3>
                </React.Fragment>
             : null}
            </div>
            <div className="col-xs-2">
              <i className="icon-flecha_lightsvg_derecha" onClick={this.props.showEditEventNameSection} />
            </div>
          </div>

        </div>
      </div>
    );
  }
}
